// src/utils/superAdminApi.js
//
// GoTrue-login-cutover task (2026-07-06) — shared helper for every call this
// dashboard makes to the Express backend's `/api/super-admin/*` routes.
// Extracted out of `SuperAdminDashboard.js` (which had its own private copy)
// so `TransactionHistory.js`, `PendingOrdersPanel.js`, and
// `utils/serverDistribution.js` — which each used to mint their own Firebase
// ID token independently via `auth.currentUser.getIdToken()` — all go through
// ONE place that knows how to get the current GoTrue access_token. That also
// means there is now exactly one spot to update if the auth mechanism ever
// changes again, instead of four.
import { supabase } from '../supabaseClient';

export const SUPER_ADMIN_API_BASE = 'https://confirming-app.dafaiagency.shop/api/super-admin';

/**
 * Fetch wrapper for the super-admin API. Attaches the current GoTrue session's
 * `access_token` as `Authorization: Bearer <token>` — replaces every call
 * site's old `auth.currentUser.getIdToken()` (Firebase). Throws (with
 * `.status` set when available) on any non-2xx response or `{success:false}`
 * body, same contract the original per-component copies used.
 */
export async function superAdminFetch(path, options = {}) {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session) {
    throw new Error('يجب تسجيل الدخول كسوبر أدمن أولاً');
  }

  const response = await fetch(`${SUPER_ADMIN_API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
      ...(options.headers || {}),
    },
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    const err = new Error(data.message || `فشل الطلب (${response.status})`);
    err.status = response.status;
    throw err;
  }
  return data;
}

export default superAdminFetch;
